import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'tpi-notification-modal',
    templateUrl: './notification-modal.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class NotificationModalComponent implements OnInit, OnDestroy {
    private cdr = inject(ChangeDetectorRef);
    private elementReference = inject(ElementRef);

    ngOnInit(): void {
        document.body.appendChild(this.elementReference.nativeElement);
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.elementReference.nativeElement.remove();
        this.cdr.detectChanges();
    }
}